import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  breadCrumb: [],
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setBreadCrumb(state, action) {
      state.breadCrumb = action.payload;
    },
  },
});

export const { setBreadCrumb } = commonSlice.actions;
export default commonSlice.reducer;
